import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, NgModule, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BxDropdownRadioModule } from '@buildxact/ui-components/bx-dropdowns';
import { TimelineMonth } from './timeline-month.model';

@Component({
    selector: 'app-ui-reminders-timeline',
    templateUrl: './ui-reminders-timeline.component.html',
    styleUrls: ['./ui-reminders-timeline.component.scss'],
    standalone: false,
})
export class UiRemindersTimelineComponent implements OnInit {
    @Input()
    moreActions: any;
    @Input()
    // @ts-ignore TS2564
    moreActionsButtonLabel: string;
    @Input()
    months: TimelineMonth[] = [];
    @Input()
    // @ts-ignore TS2564
    showAddReminder: boolean;
    @Input()
    // @ts-ignore TS2564
    showChangeStatus: boolean;
    @Input()
    // @ts-ignore TS2564
    showViewReminder: boolean;
    @Input()
    // @ts-ignore TS2564
    showDeleteReminder: boolean;

    @Output()
    onMoreAction = new EventEmitter();
    @Output()
    onCreateClick = new EventEmitter();
    @Output()
    onChangeStatus = new EventEmitter();
    @Output()
    onViewReminder = new EventEmitter();
    @Output()
    onDeleteReminder = new EventEmitter();

    constructor() {}

    ngOnInit(): void {}

    // @ts-ignore TS7006
    moreActionClicked(event) {
        this.onMoreAction.emit(event);
    }

    createClicked() {
        this.onCreateClick.emit();
    }

    changeStatus(reminder: any) {
        this.onChangeStatus.emit(reminder);
    }

    viewReminder(reminder: any) {
        this.onViewReminder.emit(reminder);
    }

    // @ts-ignore TS7006
    deleteReminder(event, reminder) {
        event.stopPropagation();
        this.onDeleteReminder.emit(reminder);
    }
}

@NgModule({
    declarations: [UiRemindersTimelineComponent],
    imports: [CommonModule, BxDropdownRadioModule, FormsModule],
    exports: [UiRemindersTimelineComponent],
})
export class UiRemindersTimelineModule {}
